const React = require('react');
const Dragula = require('react-dragula');
const MultiLineTextField = require('./components/commonControls.jsx.js').MultiLineTextField;

exports.TestPageMainContainer = class TestPageMainContainer extends React.Component{
   constructor(props) {
      super(props);
      this.state = {

      }
   }

   render() {
      return (
         <div>
            <DuoEvidence />
            <hr />
            <DragEvidence />
         </div>
      );
   }
};

const duoCreationSteps = {
   EnterText: 0,
   SelectSubject: 1,
   SelectAction: 2,
   SelectLearning: 3,
   SelectTime: 4,
};
const duoColors ={
   White: 0,
   Subject: 1,
   Action: 2,
   Learning: 3,
   Time: 4,
};

class DuoEvidence extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         enteredText: '',
         words: [],
         step: duoCreationSteps.EnterText,
      };
   }

   nextStep(){
      let nextStep = this.state.step + 1;
      this.setState({step: nextStep});
   }

   tokenizeEnteredText(){
      let tokens = this.state.enteredText.split(' ');
      let words = [];
      for(let token of tokens){
         words.push({text: token, color: duoColors.White});
      }
      this.setState({
         words,
         step: duoCreationSteps.SelectSubject,
      })
   }

   changeColor(index){
      let words = this.state.words.slice();
      if(words[index].color !== duoColors.White){
         words[index].color = duoColors.White;
      }
      else{
         if(this.state.step === duoCreationSteps.SelectSubject) {
            words[index].color = duoColors.Subject;
         }
         else if(this.state.step === duoCreationSteps.SelectAction) {
            words[index].color = duoColors.Action;
         }
         else if(this.state.step === duoCreationSteps.SelectLearning) {
            words[index].color = duoColors.Learning;
         }
         else if(this.state.step === duoCreationSteps.SelectTime) {
            words[index].color = duoColors.Time;
         }
      }
      this.setState({words});
   }

   componentDidMount() {

   }

   render() {
      if(this.state.step === duoCreationSteps.EnterText) {
         return (
            <div>
               <MultiLineTextField
                  data={this.state.enteredText}
                  isEditing={true}
                  onChange={(event) => this.setState({enteredText: event.target.value})}
                  dataField='title'
                  checkForValidationErrors={this.props.checkForValidationErrors}
                  maxLength='150'
               />
               <button className='btn btn-default' onClick={() => this.tokenizeEnteredText()}>Next</button>
            </div>
         );
      }
      else{
         let index = 0;
         let wordButtons = this.state.words.map((word) => {
            let ind = index++;
            let btnType = 'btn-default';
            if(word.color === duoColors.Subject) btnType = 'btn-subject';
            else if(word.color === duoColors.Action) btnType = 'btn-action';
            else if(word.color === duoColors.Learning) btnType = 'btn-learning';
            else if(word.color === duoColors.Time) btnType = 'btn-time';
            return(
               <button
                  className={'btn ' + btnType}
                  onClick={() => this.changeColor(ind)}
                  key={ind}
               >
                  {word.text}
               </button>
            )
         });
         return (
            <div>
               <div>
                  {wordButtons}
               </div>
               <button className='btn btn-default' onClick={() => this.nextStep()}>Next</button>
            </div>
         );
      }
   }
}

class DragEvidence extends React.Component{
   constructor(props) {
      super(props);
      this.state = {

      }
   }

   componentDidMount(){
      let container = document.getElementById('drag-container');
      Dragula([container]);
   }

   render() {
      return (
         <div className='drag-container' id='drag-container'>
            <div style={{background: '#ffb613'}}><input style={{background: '#ffb613'}} type='text' placeholder={'subject'}/></div>
            <div style={{background: '#00bde4'}}><input style={{background: '#00bde4'}} type='text' placeholder={'action'}/></div>
            <div style={{background: '#00d60f'}}><input style={{background: '#00d60f'}} type='text' placeholder={'learning/results'}/></div>
            <div style={{background: '#c260ff'}}><input style={{background: '#c260ff'}} type='text' placeholder={'year/timeframe'}/></div>
            <div style={{background: '#aaaaaa'}}><input style={{background: '#aaaaaa'}} type='text' placeholder={'extra words'}/></div>
         </div>
      );
   }
}